export default __webpack_public_path__ + "static/media/trash.8ad33ce0.svg";